import React, {useEffect, useState} from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import {HttpService, originLocalStorage} from "../../utilities";
import moment from "moment/moment";
import {getJwtExpMoment} from "../../utilities/JwtHelper";

const validateTokenFirstLoad = async () => {
  const expiredToken = getJwtExpMoment(JSON.parse(originLocalStorage.getItem()).token)
  if(expiredToken.isBefore(moment().subtract(1, 'days'))){
    throw new Error("Session too old! Logging out!");
  } else if (expiredToken.diff(moment(), 'seconds') <= 60) {
    await HttpService.getTokenAuth();
  }
}

const PrivateRoute = ({ auth, ...rest }: any) => {
  const [currentPath, setCurrentPath] = useState<string>(null)
  const [isValid, setIsValid] = useState<boolean | null>(null)

  useEffect(() => {
    setCurrentPath(location.pathname)

    if (auth == null) {
      const _url = new URL(window.location.href);
      if ((_url.pathname || "/") !== "/") {
        const return_url = _url.pathname + _url.search;
        window.localStorage.setItem('return_url', return_url);
      }
      setIsValid(false);
      return;
    }

    validateTokenFirstLoad()
        .then(() => {
          setIsValid(true);
        })
        .catch(() => {
          setIsValid(false);
        });
  }, [auth, location.pathname]);

  if(isValid === null || currentPath !== location.pathname){
    return null;
  }

  if(!isValid){
    return <Redirect to={{ pathname: auth ? '/logout' : '/' }} />
  }

  return <Route {...rest} />;
}

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth.userData
  }
};

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrivateRoute);
